import { Space, Button } from 'antd'
import useSelectColumsOperate from '../hooks/useSelectColumsOperate'
import useGetProcurementDetail from '../hooks/useGetProcurementDetail'
import useProcurementTypeContext from '../hooks/useProcurementTypeContext'
import AuthComponent from '../../../components/AuthComponent'
import { procurementTypeEnum } from '../config'

export default function PurchaseItemOperateBtns({ record, freshList, modal }) {
  const { confirmDiscard } = useSelectColumsOperate({ freshList, modal })
  const { baseKey } = useProcurementTypeContext()
  const { showDetail } = useGetProcurementDetail()
  const setShowDetail = () => {
    showDetail(record.id, record.purchaseType, {})
  }
  return (
    <Space size='small'>
      <AuthComponent authKey={baseKey + 'info/{id}'}>
        <Button size='small' type='link' onClick={() => setShowDetail(record)}>
          {record.purchaseType == procurementTypeEnum[0]
            ? '采购详情'
            : '退货详情'}
        </Button>
      </AuthComponent>
      {record.purchaseStatus != 0 && (
        <AuthComponent authKey={baseKey + 'bills-discard'}>
          <Button
            size='small'
            type='link'
            onClick={() => confirmDiscard([record.id])}>
            作废
          </Button>
        </AuthComponent>
      )}
    </Space>
  )
}
